module.exports = __webpack_public_path__ + "static/media/Proximus-Bold.4c3d376f.woff";